import { useState } from 'react';

import { Box, Button, Checkbox, FormControlLabel, Tooltip } from '@mui/material';

import { GerarReembolsoApuracaoModal } from 'pages/financeiro/reembolso/gerar-reembolso/components/GerarReembolsoApuracaoModal';
import { useGerarReembolsoContext } from 'pages/financeiro/reembolso/gerar-reembolso/contexts';

export function GerarReembolsoFooter() {
    const { hasPromocoes, refGrid, fgTodasPromocoes, setFgTodasPromocoes, setSelectedPromocoes, selectedPromocoes } = useGerarReembolsoContext();
    const [openApuracaoModal, setOpenApuracaoModal] = useState(false);
    const disableReembolso = !hasPromocoes || (!selectedPromocoes.ids.size && !fgTodasPromocoes);

    return (
        <>
            <GerarReembolsoApuracaoModal open={openApuracaoModal} setOpen={setOpenApuracaoModal} />

            <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 2 }}>
                <FormControlLabel
                    label="Selecionar todos os registros"
                    control={<Checkbox />}
                    checked={fgTodasPromocoes}
                    onChange={(_, value) => {
                        const allRowIds = refGrid?.current?.getAllRowIds();

                        setSelectedPromocoes({
                            type: 'include',
                            ids: value ? new Set(allRowIds) : new Set(),
                        });

                        setFgTodasPromocoes(value);
                    }}
                />

                <Tooltip title={disableReembolso ? 'Selecione um registro para gerar o reembolso.' : ''}>
                    <span>
                        <Button variant="contained" disabled={disableReembolso} onClick={() => setOpenApuracaoModal(true)}>
                            Gerar reembolso
                        </Button>
                    </span>
                </Tooltip>
            </Box>
        </>
    );
}
